import 'core-js/stable'
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'leaflet/dist/leaflet.css'

import App from './App.vue'
import router from './router'
import store from './store'
import { extractSsoCredentials, cleanSsoUrl } from '@/utils/sso'
import '@/styles/index.scss'

Vue.use(ElementUI, { size: 'small' })
Vue.config.productionTip = false

// 嵌入式单点登录：URL 携带账号密码时先抹除地址栏，再尝试自动登录；失败则回退正常会话恢复
const sso = extractSsoCredentials()
let boot
if (sso) {
  cleanSsoUrl()
  boot = store
    .dispatch('auth/login', { username: sso.username, password: sso.password })
    .catch(() => store.dispatch('auth/restore'))
} else {
  boot = store.dispatch('auth/restore')
}

boot.finally(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
